import * as React from 'react';
import { Card } from 'reactstrap';


type Props = {
  url: string,
}
class MobileInstructions extends React.Component<Props> {
  render() {
    const QRCodeUrl = `/qrcode.svg?content=${encodeURIComponent(this.props.url)}`

    return (
      <div className="text-center pr-5" style={{maxWidth: 300}}>
        <h3>Take photos with your phone</h3>
        <p>Scan this QRCode with your phone and you can upload photos straight from your camera.</p>
        <img src={QRCodeUrl}  className="img-fluid" />
      </div>
    );
  }
}

export default MobileInstructions;

